import Axios from '@backoffice/services/Axios'
import { BACKOFFICE_MIXIN_CONFIG } from '@backoffice/utils/constants/axios.constants'

import CookieManageMixin, { CookieManageMixinType } from './CookieManageMixin'

@CookieManageMixin
class ApiWithMixins extends Axios {}

type ApiType = Axios & CookieManageMixinType

const Api = new ApiWithMixins(BACKOFFICE_MIXIN_CONFIG) as unknown as ApiType

export default Api
